import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './MobileSubmissionDetailsHeader';
import { getDuperbrowseStreamParent, getCurrentItem } from '../../Duperbrowse/redux/selectors';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';

export type StateProps = Pick<Props, 'parent' | 'currentItem' | 'isOwner'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => {
  const currentItem = getCurrentItem(state);
  const isOwner = currentItem ? getIsCurrentUserAuthorOf(state, currentItem) : false;
  return {
    parent: getDuperbrowseStreamParent(state),
    currentItem,
    isOwner,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
